import { render, staticRenderFns } from "./CardImageComponent.vue?vue&type=template&id=50609165"
import script from "./CardImageComponent.vue?vue&type=script&lang=js"
export * from "./CardImageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports